/* Consolidate Judge.me's existing rating into the same product entity.
 * The app remains the rating source; unrelated or conflicting data is retained.
 */
(() => {
  const ratingSelector = 'script.jdgm-aggregate-rating-jld[type="application/ld+json"]';
  const permittedFields = new Set(['@context', '@type', '@id', 'name', 'aggregateRating']);

  function mergeRating(source) {
    try {
      const supplement = JSON.parse(source.textContent);
      if (supplement['@type'] !== 'Product' || !supplement['@id']) return;
      if (Object.keys(supplement).some((key) => !permittedFields.has(key))) return;
      const rating = supplement.aggregateRating;
      if (!rating || rating['@type'] !== 'AggregateRating') return;
      const value = Number(rating.ratingValue);
      const count = Number(rating.reviewCount);
      if (!Number.isFinite(value) || value < 1 || value > 5 || !Number.isInteger(count) || count < 1) return;

      const entityId = new URL(supplement['@id'], location.origin).href;
      for (const target of document.querySelectorAll('script[data-takoo-product-schema]')) {
        const product = JSON.parse(target.textContent);
        if (product['@type'] !== 'Product' || !product['@id']) continue;
        if (new URL(product['@id'], location.origin).href !== entityId) continue;
        if (product.name !== supplement.name) continue;
        if (product.aggregateRating && JSON.stringify(product.aggregateRating) !== JSON.stringify(rating)) continue;

        product.aggregateRating = rating;
        target.textContent = JSON.stringify(product);
        source.remove();
        return;
      }
    } catch {
      // Leave the original app output intact when either payload cannot be read.
    }
  }

  function inspect(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches(ratingSelector)) mergeRating(node);
    node.querySelectorAll(ratingSelector).forEach(mergeRating);
  }

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (record.target.nodeType === Node.ELEMENT_NODE && record.target.matches(ratingSelector)) {
        mergeRating(record.target);
      }
      record.addedNodes.forEach(inspect);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
  document.querySelectorAll(ratingSelector).forEach(mergeRating);
})();
